import styled from "@emotion/styled";

export const StyledPosterModalDiv = styled.div`
  .preview {
    margin-top: 16px;
    img,
    video {
      max-height: 200px !important;
    }
  }
`;

export const StyledPoster = styled.div`
  .loading {
    height: 60px !important;
  }
`;
